import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
// import styled from "@mui/material";
import React from "react";
import InfoAreaChart from "../charts/area-chart/AreaChart";
import { chartdata } from "../../../MockData/mockdataforchart";

const InfoBox = (props) => {
  return (
    <Box
      sx={{
        minHeight: 600,
      }}
      component={Paper}
      elevation={0}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            borderBottom: "5px solid #3366FF",
            py: 2,
            px: 3,
            // minWidth: "80px",
            "&:hover": {
              color: "#000",
              borderBottom: "5px solid #598bff",
            },
          }}
        >
          <Typography
            variant='h5'
            align='center'
            color={"#3366FF"}
            sx={
              {
                // "&:hover":{
                //   color:"#598bff"
                // }
              }
            }
          >
            {props.title}
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box height={"100px"} backgroundColor={"box.primary"}>
        <Stack
          direction='row'
          justifyContent='space-around'
          alignItems='center'
          py={3}
        >
          <Box>
            <Typography component='div'>Total</Typography>
            <Typography>{props.total}</Typography>
          </Box>
          <Box>
            <Typography component='div'>Last Month</Typography>
            <Typography>{props.lastMonth}</Typography>
          </Box>
          <Box>
            <Typography component='div'>Last Week</Typography>
            <Typography>{props.lastWeek}</Typography>
          </Box>
          <Box>
            <Typography component='div'>Today</Typography>
            <Typography>{props.today}</Typography>
          </Box>
        </Stack>
      </Box>
      <Divider />

      <Box px={3} py={2}>
        <InfoAreaChart chartdata={chartdata} />
      </Box>
    </Box>
  );
};

export default InfoBox;
